export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 获取游戏组列表
    gameGroupList: function gameGroupList(data) {
      return request({
        url: '/game-group/list',
        method: 'get',
        data: data
      });
    },
    // 游戏组新增
    gameGroupAdd: function gameGroupAdd(data) {
      return request({
        url: '/game-group/add',
        method: 'post',
        data: data
      });
    },
    // 游戏组修改
    gameGroupUpdate: function gameGroupUpdate(data) {
      return request({
        url: '/game-group/up',
        method: 'post',
        data: data
      });
    },
    // 游戏组删除
    gameGroupDel: function gameGroupDel(data) {
      return request({
        url: '/game-group/del',
        method: 'post',
        data: data
      });
    },
    //游戏组查看
    // gameGroupDetail(data) {
    //   return request({
    //     url: '/game-group/detail',
    //     method: 'get',
    //     data
    //   })
    // },
    // 母包类型列表
    originPkgTypeList: function originPkgTypeList(data) {
      return request({
        url: '/origin-pkg-type/list',
        method: 'get',
        data: data
      });
    },
    // 母包类型新增
    originPkgTypeAdd: function originPkgTypeAdd(data) {
      return request({
        url: '/origin-pkg-type/add',
        method: 'post',
        data: data
      });
    },
    // 母包类型修改
    originPkgTypeUpdate: function originPkgTypeUpdate(data) {
      return request({
        url: '/origin-pkg-type/up',
        method: 'post',
        data: data
      });
    },
    // 母包类型删除
    originPkgTypeDel: function originPkgTypeDel(data) {
      return request({
        url: '/origin-pkg-type/del',
        method: 'post',
        data: data
      });
    },
    // 母包列表
    originPkgList: function originPkgList(data) {
      return request({
        url: '/origin-pkg/list',
        method: 'get',
        data: data
      });
    },
    // 母包新增
    originPkgAdd: function originPkgAdd(data) {
      return request({
        url: '/origin-pkg/add',
        method: 'post',
        data: data
      });
    },
    // 母包删除
    originPkgDel: function originPkgDel(data) {
      return request({
        url: '/origin-pkg/del',
        method: 'post',
        data: data
      });
    },
    // 母包修改
    originPkgUpdate: function originPkgUpdate(data) {
      return request({
        url: '/origin-pkg/up',
        method: 'post',
        data: data
      });
    },
    //打包任务列表
    operationList: function operationList(data) {
      return request({
        url: '/operation/list',
        method: 'get',
        data: data
      });
    },
    //打包任务新增
    operationAdd: function operationAdd(data) {
      return request({
        url: '/operation/add',
        method: 'post',
        data: data
      });
    },
    // 打包任务删除
    operationDel: function operationDel(data) {
      return request({
        url: '/operation/del',
        method: 'post',
        data: data
      });
    },
    //打包任务修改
    operationUpdate: function operationUpdate(data) {
      return request({
        url: '/operation/up',
        method: 'post',
        data: data
      });
    },
    //开始打包任务
    operationStart: function operationStart(data) {
      return request({
        url: '/operation/start',
        method: 'post',
        data: data
      });
    },
    //通过ID获取母包类型详情
    originPkgTypeDetail: function originPkgTypeDetail(data) {
      return request({
        url: '/origin-pkg-type/detail',
        method: 'get',
        data: data
      });
    },
    //上传文件
    configUpload: function configUpload(data) {
      return request({
        url: '/operation/config_upload',
        method: 'post',
        data: data
      });
    },
    //打包配置添加
    subConfigAdd: function subConfigAdd(data) {
      return request({
        url: '/operation/sub_config_add',
        method: 'post',
        data: data
      });
    },
    //打包配置列表
    subConfigList: function subConfigList(data) {
      return request({
        url: '/operation/sub_config_list',
        method: 'get',
        data: data
      });
    },
    //打包配置删除
    delSubConfig: function delSubConfig(data) {
      return request({
        url: '/operation/del_sub_config',
        method: 'post',
        data: data
      });
    },
    //图标配置列表
    iconList: function iconList(data) {
      return request({
        url: '/operation/iconList',
        method: 'get',
        data: data
      });
    },
    //图标配置添加
    iconAdd: function iconAdd(data) {
      return request({
        url: '/operation/iconAdd',
        method: 'post',
        data: data
      });
    },
    //图标配置删除
    iconDel: function iconDel(data) {
      return request({
        url: '/operation/iconDel',
        method: 'post',
        data: data
      });
    },
    //图标配置修改
    iconUpdate: function iconUpdate(data) {
      return request({
        url: '/operation/iconUpdate',
        method: 'post',
        data: data
      });
    },
    //三方SDK类型配置列表
    otherSdkTypeList: function otherSdkTypeList(data) {
      return request({
        url: '/operation/otherSdkTypeList',
        method: 'get',
        data: data
      });
    },
    //三方SDK类型配置添加
    otherSdkTypeAdd: function otherSdkTypeAdd(data) {
      return request({
        url: '/operation/otherSdkTypeAdd',
        method: 'post',
        data: data
      });
    },
    //三方SDK类型配置修改
    otherSdkTypeUpdate: function otherSdkTypeUpdate(data) {
      return request({
        url: '/operation/otherSdkTypeUpdate',
        method: 'post',
        data: data
      });
    },
    //三方SDK类型配置删除
    otherSdkTypeDel: function otherSdkTypeDel(data) {
      return request({
        url: '/operation/otherSdkTypeDel',
        method: 'post',
        data: data
      });
    },
    //三方SDK列表
    otherSdkManageList: function otherSdkManageList(data) {
      return request({
        url: '/operation/otherSdkManageList',
        method: 'get',
        data: data
      });
    },
    //三方SDK删除
    otherSdkManageDel: function otherSdkManageDel(data) {
      return request({
        url: '/operation/otherSdkManageDel',
        method: 'post',
        data: data
      });
    },
    //广告渠道SDK类型列表
    adChannelSdkTypeList: function adChannelSdkTypeList(data) {
      return request({
        url: '/operation/adChannelSdkTypeList',
        method: 'get',
        data: data
      });
    },
    //广告渠道SDK类型删除
    adChannelSdkTypeDel: function adChannelSdkTypeDel(data) {
      return request({
        url: '/operation/adChannelSdkTypeDel',
        method: 'post',
        data: data
      });
    },
    //广告渠道SDK类型添加
    adChannelSdkTypeAdd: function adChannelSdkTypeAdd(data) {
      return request({
        url: '/operation/adChannelSdkTypeAdd',
        method: 'post',
        data: data
      });
    },
    //广告渠道SDK类型修改
    adChannelSdkTypeUpdate: function adChannelSdkTypeUpdate(data) {
      return request({
        url: '/operation/adChannelSdkTypeUpdate',
        method: 'post',
        data: data
      });
    },
    //广告渠道SDK列表
    adChannelSdkManageList: function adChannelSdkManageList(data) {
      return request({
        url: '/operation/adChannelSdkManageList',
        method: 'get',
        data: data
      });
    },
    //广告渠道SDK删除
    adChannelSdkManageDel: function adChannelSdkManageDel(data) {
      return request({
        url: '/operation/adChannelSdkManageDel',
        method: 'post',
        data: data
      });
    },
    //SDK秘钥文件列表
    sdkPemManageList: function sdkPemManageList(data) {
      return request({
        url: '/operation/sdkPemManageList',
        method: 'get',
        data: data
      });
    },
    ///SDK秘钥文件删除
    sdkPemManageDel: function sdkPemManageDel(data) {
      return request({
        url: '/operation/sdkPemManageDel',
        method: 'post',
        data: data
      });
    },
    //oaid文件列表
    oaidConfigManageList: function oaidConfigManageList(data) {
      return request({
        url: '/operation/oaidConfigManageList',
        method: 'get',
        data: data
      });
    },
    //oaid文件删除
    oaidConfigManageDel: function oaidConfigManageDel(data) {
      return request({
        url: '/operation/oaidConfigManageDel',
        method: 'post',
        data: data
      });
    },
    //上报配置列表
    reportConfigList: function reportConfigList(data) {
      return request({
        url: '/operation/reportConfigList',
        method: 'get',
        data: data
      });
    },
    //上报配置添加
    reportConfigAdd: function reportConfigAdd(data) {
      return request({
        url: '/operation/reportConfigAdd',
        method: 'post',
        data: data
      });
    },
    //上报配置修改
    reportConfigUpdate: function reportConfigUpdate(data) {
      return request({
        url: '/operation/reportConfigUpdate',
        method: 'post',
        data: data
      });
    },
    //上报配置删除
    reportConfigDel: function reportConfigDel(data) {
      return request({
        url: '/operation/reportConfigDel',
        method: 'post',
        data: data
      });
    },
    //打包模板列表
    subTemplateList: function subTemplateList(data) {
      return request({
        url: '/operation/sub_template_list',
        method: 'get',
        data: data
      });
    },
    //打包任务新增
    subTemplateAdd: function subTemplateAdd(data) {
      return request({
        url: '/operation/sub_template_add',
        method: 'post',
        data: data
      });
    },
    //打包任务修改
    subTemplateUp: function subTemplateUp(data) {
      return request({
        url: '/operation/sub_template_up',
        method: 'post',
        data: data
      });
    },
    //打包任务删除
    subTemplateDel: function subTemplateDel(data) {
      return request({
        url: '/operation/sub_template_del',
        method: 'post',
        data: data
      });
    }
  };
});